import { Reveal, MaskedLines } from "./Reveal";

const flow = ["ORDINE", "PRODOTTO", "BRANDING", "PACKAGING", "CLIENTE"];

export const Manifesto = () => {
  return (
    <section className="bg-ivory py-20 sm:py-28" data-testid="manifesto">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="font-sans-ui text-[11px] tracking-mega text-ink/40 mb-8">CAPITOLO 01 — L'IDEA</p>
        </Reveal>

        <h2 className="font-display font-light text-ink text-5xl sm:text-7xl lg:text-[7rem] leading-[0.95] tracking-tight">
          <MaskedLines lines={["Prima vendi.", "Poi lo rendiamo tuo."]} />
        </h2>

        <div className="grid lg:grid-cols-[1fr_0.9fr] gap-10 lg:gap-20 mt-16 sm:mt-20">
          <Reveal delay={0.1}>
            <p className="font-sans-ui text-base sm:text-lg text-ink/70 leading-relaxed max-w-xl">
              Non devi acquistare centinaia di capi, personalizzarli in anticipo e sperare di venderli.
              Con My Brand Online il processo parte dalla vendita.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <ul className="space-y-3 font-sans-ui text-base sm:text-lg text-ink/80">
              {["Il cliente ordina dal tuo store.", "Noi prendiamo l'unità venduta.", "La prepariamo con l'identità del tuo brand.", "La confezioniamo.", "La spediamo direttamente al cliente."].map((t) => (
                <li key={t} className="flex gap-4 border-b hairline pb-3">
                  <span className="text-goldtan">—</span>{t}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>

        {/* Linear flow */}
        <Reveal delay={0.15}>
          <div className="mt-20 sm:mt-28 flex flex-wrap items-center gap-x-3 gap-y-4 sm:gap-x-6">
            {flow.map((step, i) => (
              <div key={step} className="flex items-center gap-3 sm:gap-6">
                <span className="font-display text-2xl sm:text-4xl text-ink">{step}</span>
                {i < flow.length - 1 && <span className="text-goldtan text-xl sm:text-2xl">→</span>}
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="mt-20 sm:mt-28 font-display italic font-light text-4xl sm:text-6xl text-ink leading-tight">
            Ogni ordine.<br />La tua identità.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
